import React, { useState } from 'react'

import Calendar from '../../Calendar/Calendar'
import Notifications from '../../Notifications/Index'
import Matches from './Matches'
import Tabs from '../../utils/Tabs'

const tabOptions = [
  { name: 'Availabilities', value: 'matches' },
  { name: 'Notifications', value: 'notifications' }
]

const Content = () => {
  const [availabilityRequestExtra, setAvailabilityRequestExtra] = useState('matches')

  return (
    <>
      <Tabs options={tabOptions} onChange={setAvailabilityRequestExtra} />

      {availabilityRequestExtra === 'matches' && <Matches />}
      {availabilityRequestExtra === 'calendar' && <Calendar />}
      {availabilityRequestExtra === 'notifications' && <Notifications />}
    </>
  )
}

export default Content

// { name: 'Calendar', value: 'calendar' },
